import { upperFirst } from 'lodash';

const formatArrayWithPipe = (arr) => {
  return arr
    ?.map((item) => {
      if (item?.ecommerce) return upperFirst(`${item?.name} (${item?.ecommerce?.name})`);
      return upperFirst(item?.name);
    })
    ?.join(' | ');
};

export default formatArrayWithPipe;
